import React from 'react';
import Picky from 'react-picky';

import I18n from 'i18n-react';

class AirCompaniesFilter extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      originFilter: props.originFilter,
      filteredList: props.filteredList
    };
    this.selectMultipleOption = this.selectMultipleOption.bind(this);
  }

  selectMultipleOption(value) {
    this.action(value);
  }

  action = value =>
    new Promise((resolve, reject) => {
      const airCompaniesFiltered = this.state.filteredList;
      airCompaniesFiltered.companiesList = value;
      this.setState({ filteredList: airCompaniesFiltered });
      this.props.updateFilters({filteredList: airCompaniesFiltered}, this.props.flightType);
    });
  
  render() {
    const { originFilter, filteredList } = this.state;
    return (
      <div className="filter-wrapper">
        <Picky
          id="dropdown"
          options={originFilter.companiesList}
          value={filteredList.companiesList}
          onChange={this.selectMultipleOption}
          open={false}
          valueKey="id"
          labelKey="name"
          placeholder={I18n.translate('filters.airCompany')}
          multiple={true}
          includeSelectAll={true}
          includeFilter={false}
          dropdownHeight={600}
          selectAllText="Todas as cias aéreas"
          allSelectedPlaceholder="Todas as cias aéreas"
          manySelectedPlaceholder="%s Selecionadas"
          className={filteredList.companiesList.length > 0 ? 'ta-dropdown selected' : 'ta-dropdown'}
          render={({
            style,
            isSelected,
            item,
            selectValue,
            labelKey,
            valueKey
          }) => {
            return (
              <li
                style={style}
                className={isSelected ? 'ta-checkbox selected' : 'ta-checkbox'}
                key={item[valueKey]}
                onClick={() => selectValue(item)
                }
              >
                <div>
                  <input type="checkbox" checked={isSelected} readOnly />
                  <span>{item[labelKey]}</span>
                </div>
              </li>
            );
          }}
          renderSelectAll={({
            filtered,
            tabIndex,
            toggleSelectAll,
            multiple,
          }) => {
            if (multiple && !filtered) {
              return (
                <div
                  tabIndex={tabIndex}
                  role="option"
                  aria-selected="true"
                  data-selectall="true"
                  className={ filteredList.companiesList.length === originFilter.companiesList.length 
                    ? 'option selected' : 'option'}
                  onClick={toggleSelectAll}
                  onKeyPress={toggleSelectAll}
                  ref={all => this.allSelector = all}
                >
                  <span>Selecionar todas</span>
                </div>
              );
            }
          }}
        />
      </div>
    );
  }
}

export default AirCompaniesFilter;


// WEBPACK FOOTER //
// ./src/components/flightSelection/filters/airCompaniesFilter/AirCompaniesFilter.jsx